import { isLibertyLongRange } from "../publicSiteUtils";
import { libertyOpeningPhaseItems } from "./libertyContent";

export function LibertyOpeningPhasePanel({ resources = [], range, variant = "public" }) {
  if (!isLibertyLongRange(range)) {
    return null;
  }
  const phaseItems = libertyOpeningPhaseItems(resources);
  return (
    <section className={`public-liberty-phase-panel is-${variant}`} aria-label="Liberty phased opening">
      <div className="public-liberty-phase-header">
        <div>
          <span className="public-section-kicker">Phased range opening</span>
          <h3>Opening plan for early members</h3>
          <p>
            Liberty Long Range is opening in phases so the first members can start using finished areas while construction continues on the longer-range facilities.
          </p>
        </div>
        <span>Safety-first opening</span>
      </div>
      <div className="public-liberty-phase-list">
        {phaseItems.map((item) => (
          <article key={item.label}>
            <div>
              <span>{item.label}</span>
              <strong>{item.title}</strong>
              <p>{item.body}</p>
            </div>
            <em>{item.status}</em>
          </article>
        ))}
      </div>
    </section>
  );
}
